import ACTION from '../action_constant';
import API from '../api_config';
import {ajaxGetWithToken, ajaxGet,ajaxPostWithToken} from '../util/ajax';
import $ from 'jquery';
import commonFunctions from '../util/common';
const browsePackagesAction = {

  browsePackages: (params, browseFilter) => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.browseShipment + '?timestamp=' + params.timestamp + '&count=' + params.count + '&isMapView=' +  params.isMapView + '&latitude='
        + params.latitude + '&longitude=' + params.longitude + '&country=' + params.country,

        success: (data) => {
          dispatch({
            type: ACTION.BROWSE_PACKAGES.BROWSE_PACKAGES,
            data : data,
            isMapView: params.isMapView,
            browseFilter: browseFilter,
            isFilterActive: false
          });
        },
        error: (data) => {
        }
      })
    }
  },
  updateListPackages: (params) => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.baseUrl + params.url,
        success: (data) => {
          dispatch({
            type: ACTION.BROWSE_PACKAGES.UPDATE_LIST_PACKAGES,
            data : data,
            isMapView: params.isMapView
          });
        },
        error: (data) => {
          console.log(data);
        }
      })
    }
  },
  browsePackagesWithFilter: (params) => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.browseShipmentWithFilters + '?isMyTrips=' + params.isMyTrips + '&packageSize=' + params.packageSize + '&packageValueFrom=' + params.packageValueFrom +
        '&packageValueTo=' + params.packageValueTo + '&timestamp=' + params.timestamp + '&userLat=' + params.userLat + '&delivaryLat=' + params.delivaryLat +
        '&delivaryLong=' + params.delivaryLong + '&isMapView=' + params.isMapView + '&count=' + params.count + '&isCountrySearch=' + params.isCountrySearch +
        '&deliveryCountry=' + params.deliveryCountry + '&pickupCountry=' + params.pickupCountry + '&country=' +  params.country,
        success: (data) => {
          dispatch({
            type: ACTION.BROWSE_PACKAGES.BROWSE_PACKAGES_WITH_FILTERS,
            data: data,
            isMapView: params.isMapView
          });
        },
        error: (data) => {
          console.log(data);
        }
      })
    }
  },
  updateMapView: (params) => {
    return (dispatch) => {
      dispatch({
        type: ACTION.BROWSE_PACKAGES.UPDATE_MAP_VIEW,
        data: params.location,
        isMapView: params.isMapView
      })
    }
  },
  getCountryName: (params) => {
    return () => {
        const promise = $.ajax({
  					type: 'GET',
  					dataType: 'json',
  					crossDomain: true,
  					url:  API.googleGeocode + '?latlng=' + params.latitude + ',' + params.longitude + '&sensor=' + params.sensor,
  					success: function (successData) {
              successData.results[0].address_components.forEach( (address) => {
                 if(address.types[0] == "country" &&  address.types[1] == "political"){
                   return address.long_name
                 }
              })
  					},
  					error: function (errorData) {
              console.log(errorData);
            }
          })


      return promise
    }
  },
  offerToCarryPackage: (paramObj) => {
    return (dispatch) => {
      dispatch({
        type: ACTION.BROWSE_PACKAGES.OFFER_TO_CARRY_A_PACKAGE,
        data: paramObj
      })
    }
  },
  addTransportationDetails: (paramObj) => {
    return (dispatch) => {
      dispatch({
        type: ACTION.BROWSE_PACKAGES.TRANSPORT_DETAILS,
        data: paramObj
      })
    }
  },
  makeOffer: (offerData) => {
    return (dispatch) => {
      dispatch({
        type: ACTION.BROWSE_PACKAGES.MAKE_OFFER,
        offerData
      })
    }
  },getDefaultDiscount : (params) =>{
    return (dispatch) => {
      return ajaxGetWithToken({
          url : API.getDefaultDiscount+ '?userType=' + params.userType + '&shipmentCost=' + params.shipmentCost,
          success: (data) => {
          },
        error: (error) => {
          }
      })
    }
  },
  makeOfferAPI : (data) =>{
    return (dispatch) => {
      return ajaxPostWithToken({
        url : API.makeOfferAPI,
        data: data,
        success: (data) => {
        },
        error: (error) => {
        }
      })
    }
  },
  clearMakeOfferData : () =>{
    return (dispatch) => {
      dispatch({
        type: ACTION.BROWSE_PACKAGES.CLEAR_MAKE_OFFER_DATA,
        data :{}
      })
    }
  },
  getPaypalAccount: () => {
    return (dispatch) => {
      return ajaxGetWithToken({
        url: API.getPaypalAccount,
        success: (data) => {
          dispatch({
            type: ACTION.BROWSE_PACKAGES.GET_PAYPAL_ACCOUNT,
            data: data
          });
        },
        error: (data) => {
          console.log(data);
        }
      })
    }
  },
  addPaypalAccount: (paramObj) => {
    return (dispatch) => {
      return ajaxPostWithToken({
        url: API.addPaypalAccount,
        data: paramObj,
        success: (data) => {
          dispatch({
            type: ACTION.BROWSE_PACKAGES.ADD_PAYPAL_ACCOUNT,
            data: data
          });
        },
        error: (data) => {
          console.log(data);
        }
      })
    }
  },
  searchBrowseShipments: (browseFilter, viewParams) => {
    let params = Object.assign({}, browseFilter);
    // these are basic params -> step made just to make api call development easy
    let url = API.browseShipmentWithFilters +  '?isMapView=' + viewParams.isMapView + '&timestamp=' + viewParams.timestamp + '&count=' + viewParams.count;
    let delivaryFromUTC;
    let delivaryToUTC;
    delete params['country'];
    // delete delivery location details
    if(params.hasOwnProperty('delivaryLocation')){
      delete params['delivaryLocation'];
    }
    // delete pick location details
    if(params.hasOwnProperty('pickupLocation')){
      delete params['pickupLocation'];
    }
    // conversion  from local timestamp to utc timestamp
    if(params.hasOwnProperty('delivaryFrom') ){
      if(params.delivaryFrom != ''){
        delivaryFromUTC = commonFunctions.startOftheDayTimestamp(params.delivaryFrom);
        url = url + '&delivaryFrom=' + delivaryFromUTC;
      }
      delete params['delivaryFrom'];
    }
    // conversion  from local timestamp to utc timestamp
    if(params.hasOwnProperty('delivaryTo')){
      if(params.delivaryTo != ''){
        delivaryToUTC = commonFunctions.endOftheDayTimestamp(params.delivaryTo);
        url = url + '&delivaryTo=' + delivaryToUTC;
      }
      delete params['delivaryTo'];
    }
    for (let key in params){
      if(params[key] !== '' && params[key] != undefined){
        url = url + '&' + key + '=' + params[key];
      }
    }
    return (dispatch) => {
      return ajaxGetWithToken({
          url: url,
          success: (data) => {
            dispatch({
                type: ACTION.BROWSE_PACKAGES.BROWSE_PACKAGES,
                data: data,
                isMapView:viewParams.isMapView,
                browseFilter: browseFilter,
                isFilterActive: true
            });
          },
          error: (data) => {
            console.log(data);
          }
      })
    }
  },
  enableTrips: ()=>{
    return (dispatch) => {
        dispatch({
          type: ACTION.BROWSE_PACKAGES.ENABLE_TRIPS,
          isFilterActive: true
      });
    }
  },
  clearMapData: ()=>{
    return (dispatch) => {
      dispatch({
        type: ACTION.BROWSE_PACKAGES.CLEAR_MAP_DATA
      })
    }
  }
}

module.exports = browsePackagesAction;



// WEBPACK FOOTER //
// app/browse_packages/browser_packages_actions.jsx